import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavBar from '../layout/NavBar';
import PharmacyOrdersTable from './PharmacyOrdersTable.jsx';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import { PageHeader } from '../common/PageHeader';
import { createGlobalStyle } from 'styled-components';
import UploadRxModal from './UploadRxModal';
import AddApolloMedicineModal from './AddApolloMedicineModal.js'
import RefundOrderModal from './RefundOrderModal.js'
import RefundBankAmountModal from './RefundBankAmountModal.jsx'

const GlobalStyles = createGlobalStyle`
  .DateRangePicker_picker {
    z-index: 2147483647 !important;
  }
  .DateRangePickerInput {
    border: 1px solid #E3E3E3 !important;
    border-radius: 6px !important;
    background: #FAFAFA !important;
    display: flex !important;
    align-items: center !important;
    height: 36px !important;
    padding: 0 8px !important;
  }
  .DateRangePickerInput_arrow {
    color: #A5A6BB !important;
  }
  .DateInput {
    background: transparent !important;
    width: 90px !important;
  }
  .DateInput_input {
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #0F0B28 !important;
    background: transparent !important;
    border-bottom: none !important;
    padding: 0 4px !important;
    height: 34px !important;
  }
  .DateInput_input__focused {
    border-bottom: 2px solid #6C5DD3 !important;
  }
  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: #6C5DD3 !important;
    border-color: #6C5DD3 !important;
  }
  .CalendarDay__selected_span {
    background: #E5E9FE !important;
    border-color: #CFC8FF !important;
    color: #6C5DD3 !important;
  }
  .CalendarDay__hovered_span,
  .CalendarDay__hovered_span:hover {
    background: #F5F4FF !important;
    border-color: #CFC8FF !important;
    color: #6C5DD3 !important;
  }
  .DayPickerNavigation_button__default {
    border-color: #E3E3E3 !important;
  }
  .pharmacy-orders-page .revamp-table.ReactTable .rt-th,
  .pharmacy-orders-page .revamp-table.ReactTable .rt-td {
    font-weight: 600 !important;
  }
  .pharmacy-orders-page .revamp-table.ReactTable .rt-thead.-filters input,
  .pharmacy-orders-page .revamp-table.ReactTable .rt-thead.-filters select {
    font-weight: 500 !important;
  }
`;

class PharmacyOrdersHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      startDateDelivered: null,
      endDateDelivered: null,
      focusedInputDelivered: null,
      focusedInput: null,
      focusedInputCollection: null,
      phone: null,
      isUploadPrescritionModalOpened: false,
      isAddApolloMedicineOpened: false,
      isShowRefundOrderModal: false,
      isShowRefundBankAmountModal: false,
    };
  }

  showUploadPrescriptionModal = () => {
    this.setState({ isUploadPrescritionModalOpened: !this.state.isUploadPrescritionModalOpened });
  }

    showAddApolloMedicineModal = () => {
    this.setState({ isAddApolloMedicineOpened: !this.state.isAddApolloMedicineOpened });
  }

  showRefundOrderModal = () => {
    this.setState({ isShowRefundOrderModal: !this.state.isShowRefundOrderModal });
  }

  showRefundBankAmountModal = () => {
    this.setState({ isShowRefundBankAmountModal: !this.state.isShowRefundBankAmountModal });
  }
  onDatesChanged = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
  };

  onDeliveryDatesChanged = ({ startDate, endDate }) => {
    console.log(startDate, endDate);
    this.setState({ startDateDelivered: startDate, endDateDelivered: endDate });
  };

  onPhoneSearch = (e) => {
    const phone = e.target.value.trim();
    console.log(phone);
    this.setState({ phone });
  }

  render() {
    const { startDate, endDate, startDateDelivered, endDateDelivered, focusedInput, focusedInputDelivered, phone } = this.state;
    return (
      <div className="pharmacy-orders-page" style={{ width: '100%' }}>
        { this.state.isUploadPrescritionModalOpened &&
          <div>
            <UploadRxModal onClose={this.showUploadPrescriptionModal} />
          </div>
        }
        { this.state.isAddApolloMedicineOpened &&
          <div>
            <AddApolloMedicineModal onClose={this.showAddApolloMedicineModal} />
          </div>
        }
        { this.state.isShowRefundOrderModal &&
          <div>
            <RefundOrderModal onClose={this.showRefundOrderModal} />
          </div>
        }
        { this.state.isShowRefundBankAmountModal &&
          <div>
            <RefundBankAmountModal onClose={this.showRefundBankAmountModal} />
          </div>
        }
        <GlobalStyles />
        <div className="container-fluid px-0" style={{ paddingTop: '60px' }}>

          <NavBar />

          {/* ── Sticky Page Header ── */}
          <div style={{
            position: 'sticky',
            top: '60px',
            zIndex: 98,
            background: '#fff',
            borderBottom: '1px solid #E3E3E3',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            padding: '12px 24px',
          }}>
            <div style={{
              width: '36px', height: '36px', borderRadius: '8px',
              background: '#F5F4FF', border: '1px solid #E5E9FE',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '18px', flexShrink: 0,
            }}>💊</div>
            <div style={{ textAlign: 'center' }}>
              <h1 style={{ margin: 0, fontSize: '16px', fontWeight: 700, color: '#0F0B28', letterSpacing: '-0.2px', lineHeight: 1.2 }}>
                Pharmacy Orders
              </h1>
              <p style={{ margin: 0, fontSize: '11px', color: '#A5A6BB', fontWeight: 500 }}>
                Manage and track all pharmacy order requests
              </p>
            </div>
          </div>

          {/* ── Content ── */}
          <div style={{ padding: '16px 24px 32px' }}>

            {/* Search + Date filters */}
            <div style={{
              background: '#fff', border: '1px solid #E3E3E3', borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)', padding: '12px 16px',
              display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px',
              marginBottom: '16px',
            }}>
              {/* Search */}
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <svg style={{ position: 'absolute', left: '10px', pointerEvents: 'none', opacity: 0.4 }} width="13" height="13" viewBox="0 0 16 16" fill="none">
                  <circle cx="6.5" cy="6.5" r="5" stroke="#585969" strokeWidth="2" />
                  <line x1="10.5" y1="10.5" x2="14" y2="14" stroke="#585969" strokeWidth="2" strokeLinecap="round" />
                </svg>
                <input
                  placeholder="Search by phone..."
                  style={{
                    height: '34px', width: '220px',
                    paddingLeft: '30px', paddingRight: '10px',
                    fontSize: '12px', color: '#0F0B28', background: '#FAFAFA',
                    border: '1px solid #E3E3E3', borderRadius: '6px',
                    outline: 'none', transition: 'border-color 0.15s',
                  }}
                  onFocus={e => (e.target.style.borderColor = '#6C5DD3')}
                  onBlur={e => (e.target.style.borderColor = '#E3E3E3')}
                  onKeyDown={(e) => e.key === 'Enter' ? this.onPhoneSearch(e) : null}
                />
              </div>

              <div style={{ width: '1px', height: '24px', background: '#E3E3E3', flexShrink: 0 }} />

              {/* Booking Date */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ fontSize: '11px', fontWeight: 600, color: '#585969', whiteSpace: 'nowrap' }}>📅 Booking</span>
                <DateRangePicker
                  displayFormat={() => 'DD/MM/YY'}
                  startDateId="startDate" endDateId="endDate"
                  startDate={startDate} endDate={endDate}
                  isOutsideRange={() => false} minimumNights={0}
                  onDatesChange={this.onDatesChanged}
                  focusedInput={focusedInput}
                  onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                  small noBorder
                />
              </div>

              <div style={{ width: '1px', height: '24px', background: '#E3E3E3', flexShrink: 0 }} />

              {/* Delivery Date */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ fontSize: '11px', fontWeight: 600, color: '#585969', whiteSpace: 'nowrap' }}>🚚 Delivery</span>
                <DateRangePicker
                  displayFormat={() => 'DD/MM/YY'}
                  startDateId="startDateDelivered" endDateId="endDateDelivered"
                  startDate={startDateDelivered} endDate={endDateDelivered}
                  isOutsideRange={() => false} minimumNights={0}
                  onDatesChange={this.onDeliveryDatesChanged}
                  focusedInput={focusedInputDelivered}
                  onFocusChange={(focusedInputDelivered) => this.setState({ focusedInputDelivered })}
                  small noBorder
                />
              </div>

              {(startDate || endDate || startDateDelivered || endDateDelivered || phone) && (
                <span style={{
                  marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: '4px',
                  fontSize: '11px', fontWeight: 600, color: '#6C5DD3',
                  background: '#F5F4FF', border: '1px solid #E5E9FE',
                  borderRadius: '10px', padding: '2px 10px',
                }}>
                  <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#6C5DD3', display: 'inline-block' }} />
                  Filters active
                </span>
              )}
            </div>

            <PharmacyOrdersTable startDate={startDate} endDate={endDate} startDateDelivered={startDateDelivered} endDateDelivered={endDateDelivered} showUploadPrescriptionModal={this.showUploadPrescriptionModal} showAddApolloMedicineModal={this.showAddApolloMedicineModal} phone={phone} showRefundOrderModal={this.showRefundOrderModal} showRefundBankAmountModal={this.showRefundBankAmountModal} />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return;
}

export default connect(mapStateToProps)(PharmacyOrdersHome);

